export const languages: { [key: string]: string } = {
  en: 'English',
  ru: 'Русский',
  rs: 'Српски',
  kz: 'Қазақша',
}
